import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const currentAge: AnswerPathTreeNode = { path: 'currentAge', nodeId: NodeIds.insuredCurrentAge };
